module.exports = __webpack_public_path__ + "img/4.5b941847.jpg";